import { EFinancingCompany } from '@if/core/types'
import { apiClient } from '@src/services/http-common'
import { Metro2Reporting } from '@src/types/loan/loan-calendar'
import { useMutation } from '@tanstack/react-query'
import { Metro2ReportingDto } from './loan-dto'
import { transformMetro2ReportingFromDto } from './loan-transformer'

async function postMetro2Reporting(
  metro2ReportingDto: Metro2ReportingDto,
  loanId: string,
  financingCompanyId: EFinancingCompany,
): Promise<Metro2Reporting[]> {
  const response = await apiClient.post<Metro2ReportingDto[]>(
    `${financingCompanyId}/loans/${loanId}/metro2-reporting`,
    metro2ReportingDto,
  )
  return (response.data ?? []).map(transformMetro2ReportingFromDto)
}

async function deleteMetro2Reporting(loanId: string, financingCompanyId: EFinancingCompany): Promise<void> {
  await apiClient.delete(`${financingCompanyId}/loans/${loanId}/metro2-reporting`)
}

export function usePostMetro2Reporting(id: string, financingCompanyId: EFinancingCompany) {
  return useMutation({
    mutationFn: (metro2ReportingDto: Metro2ReportingDto) =>
      postMetro2Reporting(metro2ReportingDto, id, financingCompanyId),
  })
}

export function useDeleteMetro2Reporting(id: string, financingCompanyId: EFinancingCompany) {
  return useMutation({
    mutationFn: () => deleteMetro2Reporting(id, financingCompanyId),
  })
}
